import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { HearingInfo } from '../../../external/HearingInfoApi';
import { VisitReservationInfo } from '../VisitReservationInfoReducer';

export type VisitReservationBasicInfo = Pick<VisitReservationInfo, 'code' | 'firstInsDate' | 'hearingId'>;

export interface HearingInfoState {
  isLoading: boolean;
  isOpen: boolean;
  hearingInfoList: HearingInfo[];
  visitReservationInfo: VisitReservationBasicInfo;
}

export const initialHearingInfoState: HearingInfoState = {
  isLoading: false,
  isOpen: false,
  hearingInfoList: [],
  visitReservationInfo: {
    code: '',
    firstInsDate: '',
    hearingId: '',
  },
};

export const HearingInfoReducer = reducerWithInitialState(initialHearingInfoState)
  .case(actions.hearingInfo.loadingModal, (state: HearingInfoState, payload: boolean) => {
    return { ...state, isLoading: payload };
  })
  .case(actions.hearingInfo.updateDataOpenModal, (state: HearingInfoState, payload: VisitReservationBasicInfo) => {
    return { ...state, isOpen: true, visitReservationInfo: payload };
  })
  .case(actions.hearingInfo.resetHearingInfo, (state: HearingInfoState) => {
    return { ...state, ...initialHearingInfoState };
  })
  .case(actions.hearingInfo.updateHearingInfoList, (state: HearingInfoState, payload: HearingInfo[]) => {
    return {
      ...state,
      hearingInfoList: payload,
    };
  });
